(function () {
  'use strict';

  var grid = document.querySelector('.main-blog__grid');
  var showMoreWrap = document.querySelector('.blog-show-more');

  if (!grid || !showMoreWrap) return;

  var btn = showMoreWrap.querySelector('.blog-show-more__btn');

  btn.addEventListener('click', function () {
    var nextUrl = showMoreWrap.dataset.nextUrl;
    if (!nextUrl) return;

    btn.setAttribute('disabled', '');
    btn.textContent = '...';

    fetch(nextUrl)
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var newItems = doc.querySelectorAll('.main-blog__grid__item');
        var nextWrap = doc.querySelector('.blog-show-more');

        newItems.forEach(function (item) {
          grid.appendChild(item);
        });

        if (nextWrap && nextWrap.dataset.nextUrl) {
          showMoreWrap.dataset.nextUrl = nextWrap.dataset.nextUrl;
          btn.removeAttribute('disabled');
          btn.textContent = 'Show more';
        } else {
          showMoreWrap.style.display = 'none';
        }
      })
      .catch(function () {
        btn.removeAttribute('disabled');
        btn.textContent = 'Show more';
      });
  });
})();
